<template>
  <div>
    <base-page-title :titleText="pageTitle" />
    <b-row class="no-gutters p-3">
      <b-button class="ml-auto" @click="showCreateModal = true">
        {{ $t("button.createGroup") }}
      </b-button>
    </b-row>
    <b-col class="col-12 col-md-8 p-3 mx-auto">
      <groups-list />
    </b-col>

    <group-form
      :visible="showCreateModal"
      @close="showCreateModal = false"
      @created="onGroupCreated"
    />
  </div>
</template>

<script>
import GroupsList from "../components/Groups/GroupsList.vue";
import GroupForm from "../components/Groups/GroupForm.vue";

export default {
  components: {
    GroupsList,
    GroupForm,
  },
  data() {
    return {
      pageTitle: "page.groups.title",
      showCreateModal: false,
    };
  },
  methods: {
    onGroupCreated(group) {
      this.showCreateModal = false;
      this.$router.push({ name: "Group-Details", params: { id: group._id } });
    },
  },
};
</script>

<style scoped></style>
